import React, { createContext, useContext, useCallback, useRef, useState } from 'react';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '../components/ui/alert-dialog';

const ConfirmContext = createContext(null);

export const useConfirm = () => {
  const ctx = useContext(ConfirmContext);
  if (!ctx) throw new Error('useConfirm must be used within ConfirmProvider');
  return ctx.confirm;
};

export function ConfirmProvider({ children }) {
  const [state, setState] = useState({ open: false, title: '', description: '', confirmText: 'Conferma', cancelText: 'Annulla', destructive: false });
  const resolver = useRef(null);

  const confirm = useCallback((opts = {}) => {
    return new Promise((resolve) => {
      resolver.current = resolve;
      setState({
        open: true,
        title: opts.title || 'Sei sicuro?',
        description: opts.description || '',
        confirmText: opts.confirmText || 'Conferma',
        cancelText: opts.cancelText || 'Annulla',
        destructive: !!opts.destructive,
      });
    });
  }, []);

  const close = (result) => {
    setState((s) => ({ ...s, open: false }));
    if (resolver.current) { resolver.current(result); resolver.current = null; }
  };

  return (
    <ConfirmContext.Provider value={{ confirm }}>
      {children}
      <AlertDialog open={state.open} onOpenChange={(o) => !o && close(false)}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>{state.title}</AlertDialogTitle>
            {state.description ? <AlertDialogDescription>{state.description}</AlertDialogDescription> : null}
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="confirm-cancel" onClick={() => close(false)}>{state.cancelText}</AlertDialogCancel>
            <AlertDialogAction
              data-testid="confirm-ok"
              onClick={() => close(true)}
              className={state.destructive ? 'bg-destructive text-destructive-foreground hover:bg-destructive/90' : ''}
            >{state.confirmText}</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </ConfirmContext.Provider>
  );
}
